export enum ItemTypeExpression {
  Select = 'Select',
  Expand = 'Expand',
  Filter = 'FilterExpression',
  SearchText = 'SearchText',
  Distinct = 'Distinct'
}

export enum ListResponseTypeExpression {
  Select = 'Response.Select',
  Expand = 'Response.Expand'
}

export enum ListPagingExpandSurveySubmission {
  Team = 'Officer.Team'
}

export enum ListFilterTypeExpression {
  Filter = 'Filter.FilterExpression',
  SearchText = 'Filter.SearchText',
  Distinct = 'Filter.Distinct',
  ChangesSince = 'Filter.ChangesSince',
  Statuses = 'Filter.Statuses'
}

export enum ListPagingTypeExpression {
  Offset = 'Paging.Offset',
  Limit = 'Paging.Limit',
  IsDisabled = 'Paging.IsDisabled',
  Cookie = 'Paging.Cookie'
}

export enum ListPagingExpandPolygon {
  Polygon = 'Response.Expand=Polygon',
  GeofencePolygon = 'Response.Expand=Geofence.Polygon'
}

export enum ListOrderingTypeExpression {
  Ordering = 'Ordering.OrderExpression',
  ShowAtTop = 'Ordering.ShowAtTop'
}

export enum DeleteTypeExpression {
  Expression = 'FilterExpression',
  SearchText = 'SearchText',
  Distinct = 'Distinct'
}
export enum DateTypeExpression {
  start = 'Start',
  end = 'End'
}
export enum NewAlgoTypeExpression {
  UseNewAlgo = 'useNewAlgo',
  DisableFiltering = 'disableFiltering'
}

export enum CustomFilterTypeExpression {
  Expression = 'CustomExpression'
}

export type LinqExpressionType =
  | keyof typeof ItemTypeExpression
  | keyof typeof ListResponseTypeExpression
  | keyof typeof ListFilterTypeExpression
  | keyof typeof ListPagingTypeExpression
  | keyof typeof ListOrderingTypeExpression
